import { extendTheme } from '@chakra-ui/react';
import { Styles } from '@chakra-ui/theme-tools';

import breakpoints from '@/theme/foundations/breakpoints';
import colors from '@/theme/foundations/colors';
import components from '@/theme/foundations/components';
import fonts from '@/theme/foundations/fonts';
import radius from '@/theme/foundations/radius';
import shadows from '@/theme/foundations/shadows';
import space from '@/theme/foundations/space';

const styles: Styles = {
  global: () => ({
    html: {
      width: '100%',
      height: '100%',
    },

    body: {
      width: '100%',
      height: '100%',
      color: 'var(--chakra-colors-absoluteWhite)',
      backgroundColor: 'var(--chakra-colors-OlybetGrey07)',
      fontSize: '16px',
      fontWeight: '400',
    },

    '#root': {
      width: '100%',
      height: '100%',
    },

    '*': {
      boxSizing: 'border-box',
    },
  }),
};

const theme = extendTheme({
  fonts,
  colors,
  breakpoints,
  space,
  styles,
  shadows,
  components,
  radii: radius,
});

export default theme;
